import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import cookies from 'vue-cookies'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueApexCharts from "vue3-apexcharts";
import { VueSelect } from "vue-select";
import "@/assets/css/main.css"




// ✅ 1. تعریف متغیرهای سراسری در سطح فایل (برای درون ریزی در فایل‌های دیگر)
export const base_url = 'https://apibehfam-tzorc.ara-softco.ir/api';
export const download_url = 'https://apibehfam-tzorc.ara-softco.ir';
const globalVars = {
    data() {
        return {
            is_mother: store.state.is_mother,
            mother_mode: store.state.mother_mode,
            type_one: store.state.type_1,
            type_two: store.state.type_2,
            id_login: store.state.id_login,
            image_profile: store.state.image_profile,
            is_process_manager: store.state.is_process_manager,
            
            base_url: 'https://apibehfam-tzorc.ara-softco.ir/api',
            download_url: 'https://apibehfam-tzorc.ara-softco.ir',
        }
    },
}
// ایجاد نمونه اپلیکیشن
const app = createApp(App)

// 1. ثبت کامپوننت‌های جهانی
app.component("v-select", VueSelect)

// 2. استفاده از پلاگین‌ها
app
    .use(store)
    .use(VueApexCharts)
    .use(cookies)
    .use(router)
    .use(Toast, {
        rtl: true,
    })

// ✅ 3. تنظیم متغیرها برای دسترسی در تمام کامپوننت‌ها (Global Properties)
// این متغیرها در کامپوننت‌ها با this.$base_url قابل دسترسی هستند
app.config.globalProperties.$base_url = base_url;
app.config.globalProperties.$download_url = download_url;

// تنظیم مقادیر کوکی‌ها در سراسر برنامه
app.config.globalProperties.$is_mother = store.state.is_mother;
app.config.globalProperties.$mother_mode = store.state.mother_mode;
app.config.globalProperties.$type_one = store.state.type_1;
app.config.globalProperties.$type_two = store.state.type_2;
app.config.globalProperties.$id_login = store.state.id_login;
app.config.globalProperties.$image_profile = store.state.image_profile;
app.config.globalProperties.$iis_process_manager = store.state.is_process_manager;

// حذف خط mixin اگر دیگر از آن استفاده نمی‌کنید (در Vue 3 mixin کمتر توصیه می‌شود)
// .mixin(globalVars) 
app.mixin(globalVars)
app.mount('#app')